module.exports = __webpack_public_path__ + "static/media/AFSdarkgrey.dd3dcfd4.png";